import Header from './Header';
import DevWarning from './DevWarning';
import Footer from './Footer';

export default function Layout({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <main className="flex-grow w-full bg-gray-300 flex justify-center">
        <div className="bg-white pt-6 px-6 pb-2 rounded border border-gray-300 shadow-md w-10/12 lg:w-4/6">
          <DevWarning />
          {children ?? <div />}
        </div>
      </main>

      <Footer />
    </div>
  );
}
